import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#0a4447',
      borderTop: '1px solid rgba(201, 162, 39, 0.4)'
    }}>
      <div className="container" style={{
        padding: '80px 40px 40px'
      }}>
        {/* Main Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '60px',
          marginBottom: '60px'
        }}>
          {/* Brand Column */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_digital-transform-45/artifacts/c48iqw79_full_logo_web_header_400x400.png"
              alt="Resolv Digital"
              style={{ height: '60px', width: 'auto', marginBottom: '24px' }}
            />
            <p style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#888680',
              marginBottom: '24px'
            }}>
              Delivering clear, decisive digital transformation solutions that solve your business problems. For good.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a 
                href="https://www.linkedin.com/company/resolvdigital" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  border: '1px solid #C9A227',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#C9A227',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#C9A227';
                  e.currentTarget.style.color = '#1a1c1b';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#C9A227';
                }}
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '1.125rem',
              fontWeight: 700,
              color: '#dfddd6',
              marginBottom: '24px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              Services
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              {[
                { path: '/services/crm-implementation', label: 'CRM Implementation' },
                { path: '/services/erp-integration', label: 'ERP Integration' },
                { path: '/services/smart-crm', label: 'Smart CRM' },
                { path: '/services/lead-generation', label: 'Lead Generation' },
                { path: '/services/ai-enablement', label: 'AI Enablement' }
              ].map((link, index) => (
                <li key={index} style={{ marginBottom: '12px' }}>
                  <Link
                    to={link.path}
                    style={{
                      color: '#888680',
                      textDecoration: 'none',
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '1rem',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#C9A227'}
                    onMouseLeave={(e) => e.target.style.color = '#888680'}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '1.125rem',
              fontWeight: 700,
              color: '#dfddd6',
              marginBottom: '24px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              Company
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              {[
                { path: '/about', label: 'About Us' },
                { path: '/contact', label: 'Contact Us' }
              ].map((link, index) => (
                <li key={index} style={{ marginBottom: '12px' }}>
                  <Link
                    to={link.path}
                    style={{
                      color: '#888680',
                      textDecoration: 'none',
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '1rem',
                      transition: 'color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#C9A227'}
                    onMouseLeave={(e) => e.target.style.color = '#888680'}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '1.125rem',
              fontWeight: 700,
              color: '#dfddd6',
              marginBottom: '24px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              Contact
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              <li style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                marginBottom: '16px',
                color: '#888680',
                fontFamily: 'Lato, sans-serif',
                fontSize: '1rem'
              }}>
                <Mail size={20} style={{ marginTop: '2px', flexShrink: 0, color: '#C9A227' }} />
                <a href="mailto:info@resolvdigital.com.au" style={{
                  color: '#888680',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#C9A227'}
                onMouseLeave={(e) => e.target.style.color = '#888680'}
                >
                  info@resolvdigital.com.au
                </a>
              </li>
              <li style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                marginBottom: '16px',
                color: '#888680',
                fontFamily: 'Lato, sans-serif',
                fontSize: '1rem'
              }}>
                <Phone size={20} style={{ marginTop: '2px', flexShrink: 0, color: '#C9A227' }} />
                <a href="tel:+61428814091" style={{
                  color: '#888680',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#C9A227'}
                onMouseLeave={(e) => e.target.style.color = '#888680'}
                >+61 428 814 091</a>
              </li>
              <li style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                color: '#888680',
                fontFamily: 'Lato, sans-serif',
                fontSize: '1rem'
              }}>
                <MapPin size={20} style={{ marginTop: '2px', flexShrink: 0, color: '#C9A227' }} />
                <span>Gold Coast, Queensland<br />Australia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(136, 134, 128, 0.2)',
          paddingTop: '32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <p style={{
            fontFamily: 'Lato, sans-serif',
            fontSize: '0.875rem',
            color: '#888680',
            margin: 0
          }}>
            © {new Date().getFullYear()} Resolv Digital. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <Link
              to="/privacy"
              style={{
                color: '#888680',
                textDecoration: 'none',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.875rem',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#C9A227'}
              onMouseLeave={(e) => e.target.style.color = '#888680'}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              style={{
                color: '#888680',
                textDecoration: 'none',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.875rem',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#C9A227'}
              onMouseLeave={(e) => e.target.style.color = '#888680'}
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;